import { render } from "./fawrypay.vue?vue&type=template&id=2292b986&scoped=true"
import script from "./fawrypay.vue?vue&type=script&lang=js"
export * from "./fawrypay.vue?vue&type=script&lang=js"

import "./fawrypay.vue?vue&type=style&index=0&id=2292b986&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2292b986"]])

export default __exports__